export default __webpack_public_path__ + "c94db5f3862667362c6815c9b1ec8acf.woff2";